import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

interface CardWrapperProps {
  children: ReactNode;
  className?: string;
  compact?: boolean;
  hover?: boolean;
}

/**
 * A wrapper component that standardizes card appearance across the application.
 * Use this for any card-like UI element for visual consistency.
 */
export function CardWrapper({ 
  children, 
  className, 
  compact = false,
  hover = true 
}: CardWrapperProps) {
  return (
    <div 
      className={cn(
        'card-base',
        hover && 'card-hover',
        compact ? 'card-compact' : 'card-padding',
        className
      )}
    >
      {children}
    </div>
  );
} 